import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: 'Cosa ricevo esattamente con l’acquisto?',
  a: 'Ottieni accesso immediato a oltre 100 guide passo dopo passo per progetti di robot in formato PDF, più tutti i 3 bonus: il Pacchetto Arcade di cartone, La guida ai lavoretti di carta in 5 minuti e Piccoli creatori: slime e giochi sensoriali. Tutto viene consegnato in formato digitale — senza spedizione e senza attese.',
  tone: 'bg-sky-light'
}, {
  q: 'Quali materiali devo comprare?',
  a: 'Hai già in casa quasi tutto ciò che ti serve — scatole di cartone, bottiglie di plastica, nastro adesivo, elastici, tappi di bottiglia, penne e forbici. Ogni progetto elenca chiaramente in anticipo i materiali necessari, così non ci sono sorprese.',
  tone: 'bg-sunshine-light'
}, {
  q: 'Per quali età è pensato MakerLab?',
  a: 'MakerLab è pensato per bambini dai 4 ai 12 anni. I progetti sono organizzati per difficoltà: quelli facili sono perfetti per i più piccoli con un piccolo aiuto dei genitori, mentre i progetti più avanzati sono ideali per i bambini più grandi che vogliono una vera sfida di ingegneria.',
  tone: 'bg-brand-light'
}, {
  q: 'Mio figlio ha bisogno di esperienza precedente?',
  a: 'Assolutamente no. Ogni progetto parte da zero — completamente illustrato, passo dopo passo e scritto in un linguaggio semplice che ogni bambino può seguire. Non servono conoscenze di robotica, programmazione o competenze tecniche. Solo curiosità e due mani.',
  tone: 'bg-mint-light'
}, {
  q: 'Come accedo al mio acquisto?',
  a: 'Subito dopo l’acquisto riceverai un’email con un link per il download. Puoi accedere ai tuoi file da qualsiasi dispositivo — telefono, tablet o computer. I PDF possono essere aperti, salvati e stampati tutte le volte che vuoi.',
  tone: 'bg-coral-light'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-41" data-mp="1pq4hok7xwawe">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-42" data-mp="1ppcnndtzql88">
        <SectionHeading eyebrow="Domande?" title={<>Domande frequenti</>} subtitle="Tutto ciò che devi sapere prima di iniziare." data-id="element-43" data-mp="1kqrtnw5c0xs8" />
        <div className="mt-12 space-y-3" data-id="element-44" data-mp="1fpvjj0ue0fed">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`overflow-hidden rounded-2xl border border-ink/10 ${f.tone}`} data-id="element-45" data-mp="28g44t1k7zfx6" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-46" data-mp="23fpvlg6vtzxk">
                  <span className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-47" data-mp="nzzed0q839ri">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-48" data-mp="2zmb110l6e4si" />
                </button>
                <AnimatePresence initial={false} data-id="element-49" data-mp="3dfsj0gy7r9gf">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-50" data-mp="3ievmvy2gj9mt">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-ink/60" data-id="element-51" data-mp="16q71z2kq6bg9">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}